"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadPowerPinNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrcadPowerPinNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        const candidates = [];
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            for (const net of nets) {
                for (const conn of net.connections) {
                    const applies = conn.connection.appliesNetName;
                    if (applies?.labelType === 'power-pin') {
                        candidates.push({ name: applies.label.toUpperCase(), depth });
                    }
                }
            }
        }
        if (candidates.length === 0) {
            return undefined;
        }
        candidates.sort((a, b) => {
            if (a.depth !== b.depth) {
                return a.depth - b.depth;
            }
            return sigma_engine_shared_1.Utils.naturalStringSort(a.name, b.name);
        });
        return candidates[0].name;
    }
}
exports.OrcadPowerPinNamingRule = OrcadPowerPinNamingRule;
//# sourceMappingURL=OrcadPowerPinNamingRule.js.map